/* eslint-disable no-unused-expressions */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React, { useRef } from "react";
import "../../App.css";
import DataTable from "react-data-table-component";
import axios from "axios";
import { endpoints } from "../../services/apiurl";
import { withRouter } from "react-router";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { InfinitySpin } from "react-loader-spinner";
import PageTitle from "../UI/PageTitle";
class ResServiceList extends React.Component {
  // Constructor
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      DataisLoaded: false,
      rest: "",
      currentPage: 1,
      totalPages: 1,
      total: "",
      per_page: 10,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData() {
    axios.post(endpoints.res_servicelist, {}).then((response) => {
      this.setState({
        items: response.data.data,
        total: response.data.total,
        totalPages: response.data.total_pages,
        DataisLoaded: true,
      });
    });
  }

  render() {
    const { DataisLoaded } = this.state;
    const a = this.state.items;

    const b = this.state.total;

    const columns = [
      {
        selector: (row) => row.rest,
        cellExport: (row) => row.rest,
        sortable: true,
      },
      {
        selector: (row) => row.sr,
        cellExport: (row) => row.sr,
        sortable: true,
      },
    ];

    const c = [
      {
        rest: "RESTAURANT",
        sr: "PERCENTAGE",
      },
    ];
    // const data = heading.concat(c);
    const data = c.concat(a);
    const tableData = {
      columns,
      data,
    };

    if (!DataisLoaded)
      return (
        <div className="spinner">
          <InfinitySpin
            visible={true}
            width="200"
            color="#fbaa1a"
            ariaLabel="infinity-spin-loading"
          />
        </div>
      );

    return (
      <>
        <PageTitle
          title="Top Service"
          linkurl="/dashboard/feedback"
          linkTitle="View Feedback"
        />

        <div className="row mt-2">
          <DataTableExtensions {...tableData} filter={false}>
            <DataTable
              defaultSortField="id"
              pagination
              paginationPerPage={7}
              paginationRowsPerPageOptions={[7, 14, 21, 28, 35]}
            />
          </DataTableExtensions>
        </div>
      </>
    );
  }
}
export default withRouter(ResServiceList);
